module.exports = __webpack_public_path__ + "static/bbb-a0192cbe780c90095bc0cd249e1dfcaf.png";